import { FC } from 'react';
import Link from 'next/link';
import { Divider, Grid } from 'antd';

import ImageC from 'src/components/Image';
import { Title } from 'src/components/Layout/Typography';
import { IArticleByGroupDetail } from 'src/interface';
import AuthStorage from 'src/utils/auth-storage';
import { formatDate, googleArticleEvent } from 'src/utils/func';

interface MainArticleProps {
	data: IArticleByGroupDetail;
	subCategory?: string;
	headingLevel?: any;
}

const MainArticle: FC<MainArticleProps> = (props: MainArticleProps) => {
	const breakpoint = Grid.useBreakpoint();
	const userAuth = AuthStorage.tokenDecode as any;

	const imageUrl = props.data?.media_images?.find((i) => !!i?.['ar-desktop'])?.['ar-desktop'];

	const getArticleCat = (item: any) => {
		const getCat = item.cmp_article_category?.find((x: any) => x.is_primary)?.category;

		if (getCat) {
			return getCat;
		}

		return {
			full_slug: '',
			name: '-',
		};
	};

	const getArticleSlug = () => {
		const subCategory = props.subCategory;
		const slug = props.data?.slug;
		const url = props.data?.url;

		if (subCategory && !['latest', 'pilihan'].includes(subCategory)) {
			return `${subCategory?.startsWith('/') ? '' : '/'}${subCategory}/${slug}`;
		} else {
			return `/${url}`;
		}
	};

	const onClickArticle = (item: IArticleByGroupDetail) => {
		googleArticleEvent(item, userAuth, 'click');
	};

	return (
		<>
			{props.data && (
				<div className="w-full">
					<div className="w-full">
						{imageUrl && (
							<ImageC
								alt={props.data?.title}
								src={imageUrl}
								width={730}
								height={411}
								priority
								className="rounded-[10px] w-full max-w-full max-h-full md:max-w-172.5 md:max-h-96.75 lg:max-w-152.5 lg:max-h-85.5 xl:max-w-182.5 xl:max-h-102.75 h-auto object-cover"
							/>
						)}
					</div>
					<div className="flex flex-col gap-y-2 my-5 xl:pr-0">
						<a
							onClick={() => onClickArticle(props.data)}
							href={getArticleSlug()}
							className="no-underline"
						>
							<h4 className="cursor-pointer text-[18px] leading-6 font-semibold md:text-[24px] md:leading-8 md:font-bold text-neutral-3 hover:text-primary transition-colors">
								{props.data?.title}
							</h4>
						</a>
						<p className="font-normal text-neutral-7 text-[11px] leading-[19.2px] md:text-[16px] md:leading-[19.2px] lg:leading-6">
							<Link
								href={`/${getArticleCat(props.data).full_slug}`}
								className="mr-1.5 font-semibold text-primary hover:underline"
							>
								{getArticleCat(props.data).name}
							</Link>
							{formatDate(props.data?.publish_date, 'DD MMM YYYY')}
						</p>
						<p className="text-neutral-5 line-clamp-3 text-[12px] leading-4 md:text-[16px] md:leading-6">
							{props.data?.short_desc}
						</p>
					</div>
					{breakpoint.xs && <Divider className="my-1! md:my-2!" />}
				</div>
			)}
		</>
	);
};

export default MainArticle;
